import React from "react";

/**
 * Analytics Provider stub — re-enable when analytics deps are configured.
 */
export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
